import { render, staticRenderFns } from "./AddBlacklist.vue?vue&type=template&id=bbedaee8&scoped=true&"
import script from "./AddBlacklist.vue?vue&type=script&lang=js&"
export * from "./AddBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbedaee8",
  null
  
)

export default component.exports